<template>
  <div v-if="data">
    <PreviewImage :data="data" @save="bindSave"></PreviewImage>
  </div>
</template>
<script>
import PreviewImage from '@/views/business-center/components/common/preview-image/index'
import Base64 from '@/common/base64.js'
export default {
  components: {
    PreviewImage
  },
  data() {
    return {
      id: '',
      index: 0,
      index1: 0,
      data: null
    }
  },
  created() {
    this.getStorage()
    // this.getDetail();
  },
  methods: {
    previousSwiper() {
      console.log('上一个轮播图')
      if (this.index <= 0) {
        this.$toast('已经是第一页了')
        return
      }
      this.index = this.index - 1
    },
    nextSwiper() {
      console.log('下一个轮播图')
      if (this.index >= this.data.length - 1) {
        this.$toast('已经是最后一页了')
        return
      }
      this.index = this.index + 1
    },
    bindSave(data, index, isSave) {
      this.data[index].is_save = isSave ? 0 : 1
      this.$set(this.data, index, data[index])
    },
    getStorage() {
      let data = this.$route.query.data
      data = Base64.decode(decodeURIComponent(data))
      this.data = JSON.parse(data || 'null')
    },
    decodeUrlObject(obj) {
      for (let key in obj) {
        if (typeof obj[key] == 'string') {
          obj[key] = decodeURIComponent(obj[key])
        }
      }
      return obj
    },
    getDetail() {
      let params = {
        tid: this.id
      }
      this.$http
        .getApp('member/StorageLogin/getDetail', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.data = res.data
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((err) => {
          console.log(err)
          this.$toast('异常错误')
        })
    }
  }
}
</script>
<style lang="scss" scoped></style>
